import React from "react";
import PageHero from "../components/PageHero";
import { GraduationCap, Building2, Factory, Mail, Phone } from "lucide-react";

const groups = [
  {
    icon: GraduationCap,
    title: "Training Department",
    roles: [
      "Mechatronics, Automation Trainer",
      "Tool & Die Making Trainer",
      "Precision Machinist Trainer",
      "Autotronics / Automobile Mechatronics Trainer",
      "Electrical Trainer",
      "Glass Technology Trainer",
      "Welding Trainer",
      "English Trainer",
      "Maths Trainer",
      "Soft Skills Trainer",
    ],
  },
  {
    icon: Building2,
    title: "Administration",
    roles: [
      "Administration",
      "Facilities Management",
      "IT",
      "Institutional Sales",
      "Hostel Management",
      "Store",
      "Library",
      "Accounting",
      "Other",
    ],
  },
  {
    icon: Factory,
    title: "Manufacturing & Design",
    roles: [
      "Press Tool Designer",
      "Plastic Mould Designer",
      "Tool Room Expert (CNC/VMC/WireCut/EDM)",
      "Automation Engineer",
      "Automation Expert",
      "Technical Sales",
    ],
  },
];

export default function CareersPage() {
  return (
    <div data-testid="careers-page">
      <PageHero
        path="careers.hero"
        kicker="Join Our Team"
        title="Careers at Kiki Centre for Technology"
        subtitle="We have several positions within our organization that we recruit for consistently throughout the year."
      />
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-3 gap-8">
          {groups.map((g) => (
            <div key={g.title} className="bg-white rounded-2xl p-7 shadow-sm border border-slate-100">
              <div className="flex items-center gap-3 mb-5">
                <div className="h-12 w-12 rounded-xl bg-yellow-400/15 flex items-center justify-center">
                  <g.icon className="h-6 w-6 text-yellow-600" />
                </div>
                <h3 className="text-lg font-bold text-[#0B2A6B]">{g.title}</h3>
              </div>
              <ul className="space-y-2.5">
                {g.roles.map((r) => (
                  <li key={r} className="flex items-start gap-2 text-sm text-slate-600">
                    <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-yellow-400 shrink-0" />
                    {r}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto px-4 mt-14">
          <div className="rounded-2xl bg-[#0B2A6B] text-white p-8 text-center">
            <h3 className="text-2xl font-bold mb-2">Interested in joining us?</h3>
            <p className="text-slate-200 text-sm mb-6">Send your CV and the role you're applying for. Our team will get back to you.</p>
            <div className="flex flex-wrap justify-center gap-4">
              <a href="mailto:info@kikicentre.com?subject=Job Application" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg btn-primary" data-testid="careers-email-btn">
                <Mail className="h-4 w-4" /> info@kikicentre.com
              </a>
              <a href="tel:+918800288994" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg btn-outline-light" data-testid="careers-call-btn">
                <Phone className="h-4 w-4" /> +91 8800288994
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
